import { render, staticRenderFns } from "./InstallmentDetail.vue?vue&type=template&id=01c8d6e4&scoped=true"
import script from "./InstallmentDetail.vue?vue&type=script&lang=js"
export * from "./InstallmentDetail.vue?vue&type=script&lang=js"
import style0 from "./InstallmentDetail.vue?vue&type=style&index=0&id=01c8d6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c8d6e4",
  null
  
)

export default component.exports